import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/cn';

export function Card({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <section className={cn('surface-card', className)}>{children}</section>;
}

export function CardHeader({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <header className="flex items-start justify-between gap-4 border-b border-line px-5 py-4">
      {/* O titulo fica com o espaco que sobra: com a descricao longa, a acao ao lado
          era espremida e o botao quebrava em duas linhas. */}
      <div className="min-w-0 flex-1">
        <h2 className="text-[0.9375rem] font-semibold tracking-tight text-ink-900">
          {title}
        </h2>
        {description ? (
          <p className="mt-0.5 text-xs text-ink-500">{description}</p>
        ) : null}
      </div>
      {action}
    </header>
  );
}

export function CardBody({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={cn('p-5', className)}>{children}</div>;
}
